import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ShippingTermsAdapter } from './dto/shipping-terms.adapter';
import { ShippingTermsController } from './shipping-terms.controller';
import { ShippingTerms } from './shipping-terms.entity';
import { ShippingTermsService } from './shipping-terms.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ShippingTerms]),
  ],
  controllers: [ShippingTermsController],
  providers: [ShippingTermsService,ShippingTermsAdapter,ApplicationExceptionHandler,LogsService]
})
export class ShippingTermsModule {}
